import React, { useState } from 'react'
import whatsapp from '../../Images/Group 534.png'
import arrow2 from '../../Images/Vector (11).png'
import heart from '../../Images/Vector (10).png'
import arrow from '../../Images/Vector (8).png'
import plus from '../../Images/Vector@2x.png'

import './PropertyList.css'
import HomeService from '../../Services/HomeService'
import { toast } from 'react-toastify'
const PropertyDisplay = ({ e }) => {

console.log("YTR11",e);

    const [show, setShow] = useState(false)
    const [index, setIndex] = useState(null)
    const showFunc = () => {
        setShow(!show)
        setIndex(e._id)
    }

    const [remarks, setRemarks] = useState("");
      const handleRemarksSubmit = async (id) => {
        console.log("data", remarks);
        try {
          const res = await HomeService.addRemarks({
            propertyId: id,
            remarks,
          });
          if (res?.status) {
            toast.success(res.message);
          } else {
            toast.error("Error while adding Feedback!");
          }
        } catch (error) {
          console.error("Error While adding Remarks!");
        }
        setRemarks("");
      };

    return (
        <>
            <tr className={show && "borderClass"} onClick={(() => { showFunc(e._id) })}>
                <td>
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', columnGap: '10px' }}>
                        <p className='table_data_para'>{e?.locality?.name}</p>
                        <img style={{ cursor: 'pointer' }} onClick={(() => { setShow(!show) })} src={arrow}></img>
                    </div>
                </td>
                <td><p className='table_data_para' >{e?.address}</p></td>
                <td><p className='table_data_para'>{e?.area}</p></td>
                <td><p className='table_data_para'>{e?.floor}</p></td>
                <td><p className='table_data_para'>{e?.bhk}</p></td>
                <td>
                    {/* <div className='plus_div'>
                        <img style={{ cursor: 'pointer' }} src={plus}></img>
                    </div> */}
                </td>
            </tr>

            {show && <>
                <tr style={{ borderLeft: '4px solid rgb(1, 51, 102)' }}>
                    <td colSpan={7}>
                        <tr>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Property Type:
                            </td>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Available for:
                            </td>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Owner Name:
                            </td>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Contact:
                            </td>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Age:
                            </td>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Price:
                            </td>
                            <td className='table_inside_data' style={{ border: 'none !important' }}>
                                Extra:
                            </td>
                        </tr>
                        <tr>
                            <td className='table_data_1'>{e?.propertytype?.propertyType || "N/A"}</td>
                            <td className='table_data_1 text-capitalize'>{e?.propertyFor || "N/A"}</td>
                            <td className='table_data_1'>{e?.ownerName || "N/A"}</td>
                            <td className='table_data_1'>{e?.phoneNo || "N/A"}</td>
                            <td className='table_data_1'>{e?.age || "N/A"}</td>
                            <td className='table_data_1'><i class="fa fa-indian-rupee-sign"></i>{e?.price || ""}</td>
                            <td className='table_data_1'>{e?.remarks || "N/A"}</td>
                        </tr>

                        {/* <tr>
                            <td className='table_data50' colSpan={3} >
                                <div style={{ display: "flex", columnGap: '15px', marginTop: '12px' }}>
                                    <td className='table_data50'>
                                        <div className='table_inside_data_div'>
                                            <div className='table_div_check'></div>
                                            <p>Report this property</p>
                                        </div>
                                    </td>

                                    <td className='table_data50'>
                                        <div className='table_inside_data_div'>
                                            <div className='table_div_check'></div>
                                            <p>Sold Out</p>
                                        </div>
                                    </td>

                                    <td className='table_data50'>
                                        <div className='table_inside_data_div'>
                                            <div className='table_div_check'></div>
                                            <p>Rent Out</p>
                                        </div>
                                    </td>
                                </div>
                            </td>







                        </tr> */}

                        <tr>
                            <td className='table_data50' colSpan={6}>
                                <div style={{ marginTop: '10px', marginBottom: '15px' }}>
                                    <p className='para_remark'>Remark</p>
                                    <div className='remark_div'>
                                        <input type='text'
                                        value={remarks}
                                        onChange={(e) => {
                                          setRemarks(e.target.value);
                                        }}
                                        placeholder='Type something for your own use... '></input>
                                        <button
                                        onClick={() => {
                                            handleRemarksSubmit(e._id);
                                            setRemarks("");
                                          }}
                                        >Submit</button>
                                        <div className='table_data_icons_wrapper'>
                                            <div className='table_icons'>
                                                <img src={heart}></img>
                                            </div>
                                            <div className='table_icons'>
                                                <img src={whatsapp}></img>
                                            </div>
                                            <div className='table_icons'>
                                                <img src={arrow2}></img>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </td>

                </tr>
            </>}
        </>
    )
}

export default PropertyDisplay
